import { AfterViewInit, Component, NgZone, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatDrawerMode, MatSidenav } from "@angular/material/sidenav";
import { filter, Subscription } from "rxjs";
import { NavigationService } from "./providers/navigation.service";
import { TranslateServiceService } from "./providers/translate-service.service";
import { AngularFireMessaging } from "@angular/fire/compat/messaging";
import { MessagingService } from "./providers/messaging.service";
import { Router, NavigationEnd } from "@angular/router";
import { ViewportScroller } from "@angular/common";
import { ApiService } from "./providers/api.service";
import { NotificationService } from "./services/notification.service";
import firebase from 'firebase/compat/app';
import * as Cookies from 'js-cookie';
import { SM_CONSTANTS } from "./shared/constants/sm-constants";
import { AuthService } from "./providers/auth.service";
import { AutoLoginLoaderService } from "./providers/auto-login-loader.service";
import { StorageService } from "./providers/storage.service";
import { AlertService } from "./providers/alert.service";
import { StatusBar, Style } from '@capacitor/status-bar';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NetworkService } from "./providers/network.service";
import { CustomConfirmDialogComponent } from "./shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { Network } from "@capacitor/network";
import { LoaderServiceService } from "./providers/loader-service.service";
import { PushNotifications,PermissionStatus } from "@capacitor/push-notifications";
import { Platform } from "@ionic/angular";
import { environment } from "src/environments/environment";
import { GoogleApiKeyService } from "./providers/google-api-key.service";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  hideMessagePanel: boolean = true;
  @ViewChild(MatSidenav)
  sideNav!: MatSidenav;
  bodyOffset: number = 64;
  sidenavMode: MatDrawerMode = "over";
  sideNavState: boolean = true;
  hideLayout: boolean = false;
  isFromHere: boolean = false;
  apisub:Subscription
  private _obsSubscription: Subscription = new Subscription();
  private notificationSubscription: Subscription = new Subscription();
  constructor(
    private dialog:MatDialog,
    private ls: LoaderServiceService,
    private apiservice: ApiService,
    private _alertService:AlertService,
    private storageservicce:StorageService,
    private _navService: NavigationService,
    public translate: TranslateServiceService,
    private angularFireMessaging: AngularFireMessaging,
    public messagingService: MessagingService,
    private router: Router,
    private viewportScroller: ViewportScroller,
    private notificationService: NotificationService,
    private translateservice: TranslateServiceService,
    private authService:AuthService,
    private ngzone: NgZone,
    private alloader:AutoLoginLoaderService,
    private networkService: NetworkService,
    private snackBar: MatSnackBar,
    private platform: Platform,
    private apiKeyService: GoogleApiKeyService
  ) {
    
    // this.router.events
    // .pipe(filter(event => event instanceof NavigationEnd))
    // .subscribe(() => {
    //   console.log("Route changed! Closing sidenav.");
    //   this.sideNav.close();  // Close sidenav only on route change
    // });
    this.loadGoogleMapsScript();
    this.initializeApp();
    this.setStatusBar();
    this.monitorNetwork();
    this.handleBackButton()

    this.router.events.subscribe(() => {
      this.checkCurrentRoute();
    });

    this.translateservice.useLanguage('en');
    translate.getLanguage();

    // this.messagingService.requestPermission();
    
    this.notificationService.initFCM();
    this.listenForAllNotifications();
   
    this.apisub = this.apiservice.apiResult.subscribe(res => {
      if (res.responseType === SM_CONSTANTS.GET_USER_DETAIL_RESULT) {
      
        if (res.result) {
          if (
            !res.result.profileHashId ||
            res.result.profileHashId == "null"
          ) {
            // this.authService.onSignOut();
          } else {
           
            this.storageservicce
              .getValueFromLocalStorage(SM_CONSTANTS.KEY_FCM_TOKEN)
              .then(async (value) => {
                console.log("valueiss", value);

                if (value && value != "null" && value != null) {
                  console.log("token exists");
                  console.log("tokenvalueis:::", value);
                 
                  console.log('profile token is::::>>>>>', res.result.fcm_token);
                  
                  if (
                    res.result.fcm_token !=
                      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) ||
                    !res.result.fcm_token
                  ) {

                    const permissionStatus: PermissionStatus = await PushNotifications.checkPermissions();
                    console.log("check permissions:::::>>>>>", permissionStatus.receive);
                    
                    if (permissionStatus.receive == 'granted') {
                      const requestStatus = await PushNotifications.requestPermissions();
                      console.log("request permissions:::::>>>>>", requestStatus.receive);
                      
                      if (requestStatus.receive == 'granted') {
                        console.log("granted also true");
  
                        let bodyData = {
                          fcmToken: localStorage.getItem(
                            SM_CONSTANTS.KEY_FCM_TOKEN
                          ),
                        };
  
                        this.apiservice.updateFcmTokenInfo(
                          localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
                          bodyData
                        );  
                      }
                      else{
                        console.error("notification permission not granted");
                        return;
                      }
                    }


                    // if (Notification.permission == "granted") {
                    //   console.log("granted also true");

                    //   let bodyData = {
                    //     fcmToken: localStorage.getItem(
                    //       SM_CONSTANTS.KEY_FCM_TOKEN
                    //     ),
                    //   };

                    //   this.apiservice.updateFcmTokenInfo(
                    //     localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
                    //     bodyData
                    //   );
                    // } else {
                    //   console.log("notification permission not granted");
                    // }
                  }
                }
              });
          }
        }
      }
      
      if (res.responseType === SM_CONSTANTS.GET_USER_DETAIL_RESULT_TO_SET_COOKIE) {
        if (res.result) {

          if(!this.platform.is('capacitor')){
            
                        
                        //SETTING COOKIE FOR SSO
                        let accId = localStorage.getItem(
                          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
                        );
                        let prfId = res.result.profileHashId;
                        let aCountryCode = localStorage.getItem(
                          SM_CONSTANTS.KEY_ACCOUNT_COUNTRY_CODE
                        );
                        let aPhone = localStorage.getItem(
                          SM_CONSTANTS.KEY_NEW_ACCOUNT_PHONE_NUMBER
                        );
            
                        document.cookie = `accId=${accId};Domain=.lookzup.com;Max-Age=2592000;Path=/;`;
                        document.cookie = `prfId=${prfId};Domain=.lookzup.com;Max-Age=2592000;Path=/;`;
                        document.cookie = `aCountryCode=${aCountryCode};Domain=.lookzup.com;Max-Age=2592000;Path=/;`;
                        document.cookie = `aPhone=${aPhone};Domain=.lookzup.com;Max-Age=2592000;Path=/;`;

          }


        }
      }

      if (res.responseType === SM_CONSTANTS.CHECK_USER_RESULT) {
        if(!this.platform.is('capacitor')){
          if(this.isFromHere){
            console.log(res);
            this.isFromHere = false
            if (res.result) {
              this.storageservicce.setLocalStorageValue(
                SM_CONSTANTS.KEY_NEW_ACCOUNT_PHONE_NUMBER,
                this.getCookie('aPhone')!
              );
              this.storageservicce.setLocalStorageValue(
                SM_CONSTANTS.KEY_ACCOUNT_COUNTRY_CODE,
                this.getCookie('aCountryCode')!
              );
  
              if (
                res.result.block_status &&
                res.result.block_status == '2'
              ) {
                this.authService.onSignOutWithoutRedirect()
                this.router.navigate(['/login'])
              } else {
                if (res.result.errorcode == '1') {
                  this.storageservicce.setLocalStorageValue(
                    SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
                    res.result.accountHashID
                  );
  
                  //registered but no profile
                  if (
                    !res.result.profile_hash ||
                    res.result.profile_hash == 'null'
                  ) {
                    this.authService.onSignOutWithoutRedirect()
                    this.router.navigate(['/login'])
                    // this.showProfileForm = true;
                  }
  
                  //registered and having profie
                  else if (
                    res.result.profile_hash &&
                    res.result.profile_hash != 'null'
                  ) {
                    console.log('incoming');
  
                    //( make cases for mobile and laptop)
                    localStorage.setItem(
                      SM_CONSTANTS.PROFILE_HASH,
                      res.result.profile_hash
                    );
                    localStorage.setItem(
                      SM_CONSTANTS.PROFILE_CODE,
                      res.result.profile_code
                    );
  
                    this.router.navigateByUrl('/dashboard').then((_) => {
                      this.alloader.showLoader = false
                      
                      this._alertService.onOpenSnackbar('Logged in successfully');
                    });
  
                  } else {
                    this._alertService.onOpenSnackbar(
                      'Some error occured. Please try again.'
                    );
                  }
                  this.apiservice.getUserDetail(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID));
                } else if (res.result.errorcode == '0') {
                  this.storageservicce.setLocalStorageValue(
                    SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
                    res.result.accountHashID
                  );
                  // this.showProfileForm = true;
                } else {
                  this._alertService.onOpenSnackbar(res.result.message, 4000);
                }
              }
            }
          }

        }

      }
     

     
    })


  }

  ngOnInit() {
    
    // Cookies.set('adf', 'valueWithSignature', { expires: 1, secure: true, sameSite: 'Strict' });

    const obsSub = this._navService.layoutConfig.subscribe((state) => {
      console.log(state);

      this.hideLayout = state.singlePage;
      this.sideNavState = !state.matches;
      this.bodyOffset = state.matches ? 56 : 64;
      this.sidenavMode = state.matches ? "push" : "side";
    });
    this._obsSubscription.add(obsSub);



    if (this.platform.is('capacitor')) {


 // ACCOUNT IDS PRESENT
 if (
  localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID) &&
  localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID) != 'null' && localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_AUTH_ID) && localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_AUTH_ID) != 'null'
){
  console.log('Statement::::COOKIE EXIST AND LOCAL ACCOUNT IDS EXIST -> LOGIN VIA LOCAL');

  this.apiservice.getUserDetail(
    localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)
  );
}
else{
    this.authService.onSignOutWithoutRedirect();
    this.ngzone.run(()=> {
      this.router.navigate(['app-version-check'])

    })
}
}

else if(!this.platform.is('capacitor')){
  console.log('running in web');


       // COOKIE PRESENT
       if(this.getCookie('fbid') && this.getCookie('fbid') != 'null' && this.getCookie('fbid') != undefined){
        this.renewAllCookies(30);
        // ACCOUNT IDS PRESENT
        if (
          localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID) &&
          localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID) != 'null' && localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_AUTH_ID) && localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_AUTH_ID) != 'null'
        ){
          console.log('Statement::::COOKIE EXIST AND LOCAL ACCOUNT IDS EXIST -> LOGIN VIA LOCAL');
  
          this.apiservice.getUserDetail(
            localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)
          );
        }
        // ACCOUNT IDS ABSENT
        else{
          console.log('Statement::::COOKIE EXIST BUT LOCAL ACCOUNT IDS DOESNT EXIST -> AUTO LOGIN VIA COOKIE'); //NEED TO HIT HERE

            this.ngzone.run(() => {
              this.router.navigate(['/auto-login'])
            })
            this.authService.autoLogin().then(res => {
              if(res){
                console.log(res);
                this.isFromHere = true
                this.alloader.showLoader = false
                localStorage.setItem(SM_CONSTANTS.KEY_ACCOUNT_AUTH_ID, this.getCookie('fbid')!);
                const apiBodyData = {
                  versionCode: '1.0.0',
                  appType: 'web',
                  appName: 'business',
                  countryCode: this.getCookie('aCountryCode')
                }
    
                this.alloader.showLoader = true
                this.apiservice.checkUser(apiBodyData, this.getCookie('fbid')!, this.getCookie('aPhone')!);
              }
    
            })
            .catch(err => console.error(err));
            //  this.authService.onSignOutWithoutMessage();
  
          }
      }
      // COOKIE ABSENT
      else{
        // ACCOUNT IDS PRESENT
        if (
          localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID) &&
          localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID) != 'null' && localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_AUTH_ID) && localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_AUTH_ID) != 'null'
        ){
          console.log('Statement::::COOKIE DOESNT EXIST BUT LOCAL ACCOUNT IDS EXIST -> LOGGING OUT');
          if(environment.production){
          this.authService.onSignOutWithoutMessage();

        }
        }
        else{
          // APPROPRIATE ACTION ACCORDING TO APP (COULD BE 'DO NOTHING')
          console.log('Statement::::COOKIE DOESNT EXIST AND LOCAL ACCOUNT IDS DOESNT EXIST -> APP SPECIFIC ACTION');
          this.authService.onSignOutWithoutMessage();
        }
      }
  
}


  }

initializeApp() {
  App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
    this.ngzone.run(() => {
      try {
        const url = new URL(event.url);
        const pathWithQuery = url.pathname + url.search;
        console.log('DEEPLINKING WORKS---->>>>', pathWithQuery);
        
        if (pathWithQuery) {
          this.router.navigateByUrl(pathWithQuery);
        }
      } catch (err) {
        console.error('Invalid URL:', event.url, err);
      }
    });
  });
  // App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
  //       this.ngzone.run(() => {
  //           // Example url: https://beerswift.app/tabs/tab2
  //           // slug = /tabs/tab2
  //           const slug = event.url.split(".app").pop();
  //           if (slug) {
  //               this.router.navigateByUrl(slug);
  //           }
  //           // If no match, do nothing - let regular routing
  //           // logic take over
  //       });
  //   });
}


  createNotification(title:any, text:any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

  
  checkCurrentRoute() {
    // Add the routes where you want to hide the sm-message-panel
    const routesToHidePanel = ['/login', '/register', '/', '/messages', '/auto-login']; // Add other routes as needed

    const currentPath = this.router.url.split('?')[0];

    this.hideMessagePanel = routesToHidePanel.includes(currentPath);
  }

  checkCurrentRouteForQuery() {
    const routesToNotShowPopup = [
      '/businesses/details/joining-query-list',
      '/all-bookings'
    ];
  
    // Get the current URL path without query parameters
    const currentPath = this.router.url.split('?')[0];
  
    // Check if the current path matches any route in the list
    if (routesToNotShowPopup.includes(currentPath)) {
      return false;
    }
    return true;
  }

  listenForAllNotifications() {
    this.notificationSubscription = this.notificationService.getAllNotifications()  
      .subscribe(payload => {
        this.handleNotificationByType(payload);
      });
  }

  handleNotificationByType(payload: any) {
    const type = payload.data.type;
    console.log("payload type:::>>>", type);
    
    switch (type) {
      // case 'newbooking':
      //   this.handleNewBooking(payload);
      //   break;
      case 'updateMessageThread':
        this.handleMessageThreadUpdate(payload);
        break;
      case 'newJoiningQuery':
        this.handleNewQuery(payload);
        break;
      case 'membershipQueryStatusUpdated':
        this.handleQueryStatusUpdate(payload);
        break;
      case 'onMemberAttendance':
        this.handleMemberAttendance(payload);
        break;
      case 'onBusinessActivation':
        this.handleMemberAttendance(payload);
        break;
      // Add other cases as needed
      default:
        console.log('new notification recieved', JSON.stringify(payload))
        this.apiservice.getMessageNotificationStatus()
    }
  }


  handleMessageThreadUpdate(payload: any) {
    console.log("new message received", payload);
    this.apiservice.getMessageNotificationStatus() //STOP THIS IF ITS ON THE MESSAGE SCREEN
  }
  handleNewQuery(payload: any) {
    console.log("new notification received", payload);
    if(this.checkCurrentRouteForQuery()){
      // this.createNotification(payload.data.title, payload.data.message)

    }
    this.apiservice.getMessageNotificationStatus() //STOP THIS IF ITS ON THE QUERIES/show all SCREEN
  }
  handleQueryStatusUpdate(payload: any) {
    console.log("new notification received", payload);
    if(this.checkCurrentRouteForQuery()){
      // this.createNotification(payload.data.title, payload.data.message)

    }
    this.apiservice.getMessageNotificationStatus() //STOP THIS IF ITS ON THE QUERIES/show all SCREEN
  }
  handleMemberAttendance(payload: any) {
    console.log("new notification received", payload);
    if(this.checkCurrentRouteForQuery()){
      // this.createNotification(payload.data.title, payload.data.message)

    }
    this.apiservice.getMessageNotificationStatus() //STOP THIS IF ITS ON THE QUERIES/show all SCREEN
  }
  handleActivationDeactivation(payload: any) {
    console.log("new notification received globally app component", payload);
    // this.createNotification(payload.data.title, payload.data.message)
  
    this.apiservice.getMessageNotificationStatus() //STOP THIS IF ITS ON THE QUERIES/show all SCREEN
  }

  ngOnDestroy() {
    this._obsSubscription.unsubscribe();
  }

  getAuthTokenFromCookie(): string | null {
    const cookies = document.cookie.split("; ");
    console.log('coooooo', cookies);
    
    const authCookie = cookies.find(row => row.startsWith("authId="));
    return authCookie ? authCookie.split("=")[1] : null;
  }

  getCookie(name: string): string | null {
    const matches = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return matches ? decodeURIComponent(matches[1]) : null;
  }

  renewAllCookies(days:any) {
    
    let cookies = document.cookie.split("; ");
    
    cookies.forEach(cookie => {
        let [name, value] = cookie.split("=");

        if (name && value) {
            let expires = new Date();
            expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000)); // Extend expiration
            
            document.cookie = `${name}=${value}; Domain=.lookzup.com; Expires=${expires.toUTCString()};Path=/;`;
        }
    });
}

async setStatusBar() {
  try {
    await StatusBar.setOverlaysWebView({ overlay: false });
    await StatusBar.setStyle({ style: Style.Light }); // Use 'light' for dark backgrounds
    await StatusBar.setBackgroundColor({ color: '#ffffff' }); // Change as needed
    await StatusBar.show()
  } catch (error) {
    console.error('StatusBar Error:', error);
  }
}

handleBackButton() {
  App.addListener('backButton', ({ canGoBack }) => {
    if (this.dialog.openDialogs.length > 0) {
      // If any dialog is open, close the topmost one
      this.dialog.closeAll();
      return;
    }

    if (!canGoBack) {
      // If there's no navigation history, exit the app
      App.exitApp();
    } else {
      if (this.router.url === '/dashboard') {
        App.exitApp();
      } else {
        window.history.back();
      }
    }
  });
}

ngAfterViewInit() {
  this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(() => {
      if (this.sideNav) {
        console.log("Route changed! Closing sidenav.");
        this.sideNav.close();  // Close sidenav only on route change
      }
    });
}

wasOffline = false;

monitorNetwork() {
  this.networkService.getNetworkStatus().subscribe((isConnected) => {
    if (!isConnected) {
      // Only show offline snackbar if this is a transition
      if (!this.wasOffline) {
        this.wasOffline = true;
        this.showRetryDialog();
      }
    } else {
      // Only show 'Back online' if we were offline before
      if (this.wasOffline) {
        this.wasOffline = false;
        this.ls.showLoader = false
        this.snackBar.dismiss();
        this.snackBar.open('Back online!', '', {
          duration: 3000,
          horizontalPosition: "center",
          verticalPosition: "top",
          panelClass: 'snack-success',
        });

        setTimeout(() => {
          window.location.reload();
        }, 1000); // slight delay for smoother UX
      }
    }
  });
}

showRetryDialog() {
  this.ls.showLoader = false
  this.snackBar.dismiss(); // Clear any existing ones
  this.snackBar.open('You are offline!', '', {
    duration: 5000,
    horizontalPosition: "center",
    verticalPosition: "top",
    panelClass: 'snack-error',
  });


}



// FOR PULL DOWN TO REFRESH
touchStartY = 0;
pullProgress = 0;
isRefreshing = false;
pullThreshold = 80;

onTouchStart(event: TouchEvent) {
  if (this.isRefreshing) return;
  this.touchStartY = event.touches[0].clientY;
}

onTouchMove(event: TouchEvent) {
  if (this.isRefreshing) return;

  const currentY = event.touches[0].clientY;
  const diff = currentY - this.touchStartY;

  if (diff > 0 && diff < 150) {
    this.pullProgress = diff;
  }

  if (diff >= this.pullThreshold && !this.isRefreshing) {
    this.triggerRefresh();
  }
}

onTouchEnd() {
  if (!this.isRefreshing) {
    this.pullProgress = 0;
  }
}

triggerRefresh() {
  this.isRefreshing = true;

  // Simulate network/data refresh
  setTimeout(() => {
    this.isRefreshing = false;
    this.pullProgress = 0;
  }, 1500);
}

loadGoogleMapsScript() {
    const apiKey = this.apiKeyService.getApiKey();
    const scriptId = 'google-maps-api';

    if (document.getElementById(scriptId)) return; // prevent duplicate

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.defer = true;
    // if(!environment.production){
    //       this.snackBar.open('GOOGLE API KEY USED: ' + apiKey,'Ok')

    //     }  
    
    document.head.appendChild(script);
  }

}




// OLD FCM PERMISSION CODE
// document.addEventListener("DOMContentLoaded", function () {
//   if (!Notification) {
//     alert(
//       "Desktop notifications not available in your browser. Try Chromium."
//     );
//     return;
//   }

//   if (Notification.permission !== "granted")
//     Notification.requestPermission();
//   //  alert("Please allow notifications permission to receive live updates on our platform.")
// });